import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';
import { riskIdentSnippet } from '../../default/order/order';

export const orderConfig: DeepPartial<OrderConfig> = {
  paymentMethods: ['mastercard', 'visa', 'amex', 'paypal', 'klarna_sofort', 'diners', 'discover'],
  bankInformation: {
    companyName: 'BAUR Versand GmbH & Co KG',
    bankName: 'Commerzbank Coburg',
    iban: 'DE54 7834 0091 0850 9333 01',
    bic: 'COBADEFFXXX',
  },
  paylink: {
    respectTypeFromApi: true,
    paymentMethods: ['paypal', 'mastercard', 'visa', 'amex', 'diners', 'discover', 'wero'],
  },
  paymentProtection: {
    showIcon: false,
    boxColor: 'white',
  },
  premium: {
    enabled: true,
    hasRuntimeOptions: true,
    hasLegalFooter: false,
    trackingDetail: 'VKP',
  },
  parcelShop: {
    apiKey: 'ad86364d-5f45-4',
    countriesIdentifier: 'DE',
  },
  riskIdent: {
    enabled: true,
    snippetId: riskIdentSnippet('67Gvgz'),
  },
  sovendus: {
    de: {
      trafficSourceNumber: '183',
      trafficMediumNumber: { default: '121', mobile: '122', app: '123' },
    },
  },
};
